import { GET_ROLES } from '../actionTypes'
import { Role } from '../reducers/role'

export const getRolesAction = (roles: Role[]) => ({ type: GET_ROLES, payload: roles })
